import { render, staticRenderFns } from "./caseProduct.vue?vue&type=template&id=0f404325&scoped=true"
import script from "./caseProduct.vue?vue&type=script&lang=js"
export * from "./caseProduct.vue?vue&type=script&lang=js"
import style0 from "./caseProduct.vue?vue&type=style&index=0&id=0f404325&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f404325",
  null
  
)

export default component.exports